import * as actionTypes from "./actionTypes";

export const constructUpdatedAddress = (name, value) => {
  return {
    type: actionTypes.ADD_UPDATED_ADDRESS_PARAM,
    paramName: name,
    paramValue: value,
  };
};
export const resetUpdatedAddress = () => {
  return {
    type: actionTypes.RESET_UPDATED_ADDRESS_PARAM,
  };
};
export const shouldUploadDocument = (shouldUpload: boolean) => {
  //console.log("shouldUpload",shouldUpload)
  return {
    type: actionTypes.SHOULD_UPLOAD_DOCUMENT,
    shouldUpload: shouldUpload,
  };
};
